
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11510',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11510",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.444",
  "dashboard-client-types": "static-1.214",
  "data-fetching-client": "static-1.9463",
  "foundations-components": "static-1.7492",
  "foundations-components-legacy": "static-1.517",
  "foundations-theming": "static-1.4194",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.77",
  "head-dlb": "static-1.4754",
  "hs-test-utils": "static-1.7789",
  "hub-http-shared-msw-handlers": "static-1.9441",
  "hubspot-dlb": "static-2.1796",
  "hubspot-url-utils": "static-1.3917",
  "HubStyleTokens": "static-2.11207",
  "I18n": "static-7.1564",
  "jasmine-runner": "static-1.6256",
  "marketplace-storefront-base": "static-1.11570",
  "quartz": "static-1.6705",
  "react-dlb": "static-1.71",
  "react-rhumb": "static-1.16427",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2646",
  "reporting-testing-lib": "static-1.8384",
  "settings-ui-lib": "static-1.12306",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6697",
  "ui-addon-i18n": "static-1.10919",
  "ui-addon-react-router-dom": "static-1.9332",
  "unified-auth": "static-1.184",
  "unified-auth-core-lib": "static-1.465",
  "usage-tracker": "static-1.7116",
  "usage-tracker-core": "static-1.6966",
  "customer-data-property-utils": "static-1.7857",
  "history": "static-4.47",
  "hub-http": "static-1.5966",
  "integrations-lib": "static-1.15367",
  "marketplace-ui-common": "static-1.18892",
  "property-management-iframe": "static-1.12267",
  "quartz-config": "static-1.483",
  "quartz-core": "static-1.5924",
  "quartz-routing": "static-1.135",
  "quick-fetch": "static-1.3719",
  "react": "static-7.177",
  "rpc-client-utils": "static-1.4416",
  "ts-schema": "static-1.3888",
  "ui-universal-auth": "static-1.8670",
  "UIComponents": "static-3.8154",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.387",
  "hs-promise-rejection-tracking": "static-1.5291",
  "PortalIdParser": "static-2.349",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9391",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "styled-components": "static-2.84",
  "bend-plugin-trellis-migration": "static-1.3211",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.2982",
  "quartz-webpack": "static-1.2929",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3761",
  "floating-ui": "static-1.51",
  "foundations-assets": "static-1.4619",
  "foundations-theming-specialty": "static-1.1910",
  "framer-motion": "static-1.67",
  "hs-story-utils": "static-1.9213",
  "react-aria": "static-1.61",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5158",
  "react-virtualized": "static-2.94",
  "StyleGuideUI": "static-3.483",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1145",
  "ui-fonts": "static-1.469",
  "ui-images": "static-2.1087",
  "bend-plugin-foundations-theming": "static-1.2677",
  "foundations-theming-base": "static-1.3179",
  "stylex": "static-1.27",
  "HeadJS": "static-2.706",
  "hs-test-utils-bend-plugin": "static-1.2900",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4112",
  "ai-components-ui-library": "static-1.8306",
  "ai-rendering-library": "static-1.9249",
  "chirp-fetch": "static-1.1667",
  "connections-embed-lib": "static-1.603",
  "copilot-toolkit": "static-1.10482",
  "laboratory-lib": "static-3.6946",
  "marketplace-embed": "static-1.21442",
  "marketplace-ui-details": "static-1.8788",
  "marketplace-ui-reviews": "static-1.18848",
  "marketplace-ui-tracking": "static-1.13063",
  "sanitize-text": "static-1.7923",
  "ui-addon-video-player": "static-1.8479",
  "usage-tracker-multi": "static-1.5530",
  "usage-tracker-session-replay": "static-1.4802",
  "wootric-nps": "static-1.6766",
  "apollo-link-hub-http": "static-2.4432",
  "immer": "static-1.33",
  "immerable": "static-1.3938",
  "highcharts": "static-8.99",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2385",
  "reporting-data": "static-1.66451",
  "cssUtils": "static-1.726",
  "flux-actions": "static-1.306",
  "HubStyle": "static-2.11515",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.9995",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10157",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7106",
  "icons": "static-2.620",
  "marketplace-ui-apps-core": "static-1.17425",
  "storybook-react": "static-1.28",
  "trellis-story-utils": "static-1.4307",
  "foundations-components-test-utils": "static-1.4975",
  "quartz-i18n": "static-1.380",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3515",
  "customer-data-objects": "static-1.7430",
  "property-translator": "static-1.5197",
  "frontend-preferences-client": "static-1.7708",
  "hs-promise-utils": "static-1.5376",
  "hubspot-apollo-client": "static-1.4664",
  "integrations-error-boundary-lib": "static-1.12782",
  "integrations-tracking-lib": "static-1.5369",
  "native-integrations-shared-strings": "static-1.7572",
  "reselect": "static-2.16",
  "sanitize": "static-1.4259",
  "superstore": "static-1.4555",
  "ui-shepherd-react": "static-3.9929",
  "ai-settings-ui-library": "static-1.7406",
  "hub-http-janus": "static-1.789",
  "hubspotter-http": "static-1.4462",
  "immutable-less": "static-1.4437",
  "marketplace-ui-client-types": "static-1.16299",
  "nav-meta": "static-1.28856",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10020",
  "ui-addon-upgrades": "static-9.17628",
  "inbound-db-properties-service-client": "static-1.3660",
  "property-management-common": "static-1.4554",
  "ui-addon-iframeable": "static-1.8827",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.479",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.380",
  "quartz-head": "static-1.370",
  "quartz-test": "static-1.380",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2926",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20243",
  "ContentUtils": "static-1.67577",
  "sassPrefix": "static-1.151",
  "avatar-components": "static-1.2268",
  "customer-data-filters-ui": "static-1.38852",
  "customer-data-objects-ui-components": "static-1.12789",
  "customer-data-reference-ui-components": "static-1.12926",
  "embedded-academy-lib": "static-1.13449",
  "ExportDialog": "static-6.10170",
  "highlight.js": "static-1.74",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40617",
  "reporting-snowflake": "static-1.55069",
  "reporting-ui-components": "static-2.63722",
  "reporting-visualizations": "static-1.58527",
  "ui-addon-teams": "static-1.21218",
  "magpie-lib": "static-1.5378",
  "magpie-types": "static-1.4838",
  "simple-logging-lib": "static-1.2834",
  "navigation-components": "static-1.17219",
  "ai-studio-lib": "static-1.10956",
  "developer-experience-shared-components": "static-1.10251",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7769",
  "ui-tool-access": "static-1.9928",
  "usage-based-billing-components-lib": "static-1.7960",
  "usage-tracker-anonymous": "static-1.5533",
  "usage-tracker-public": "static-1.6927",
  "amplitude-session-replay-browser": "static-1.55",
  "inbound-db-meta-service-client": "static-1.3402",
  "persist-promise": "static-1.3490",
  "reference-resolvers": "static-1.7945",
  "ui-extensibility-client-types": "static-1.3730",
  "hubspot-apollo-cache": "static-1.123",
  "universal-page-editor-lib": "static-1.2782",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2145",
  "merchandise-lib": "static-1.258",
  "atom": "static-1.4854",
  "purchase-motions-components": "static-1.5460",
  "salesImages": "static-1.520",
  "batch-promise": "static-1.1333",
  "crm-component-utils": "static-1.38454",
  "crm-properties-common-lib": "static-1.5655",
  "framework-data-schema-resolvers": "static-1.6654",
  "reference-resolvers-lite": "static-1.7875",
  "navigation-messaging": "static-1.6546",
  "hubspotter-http-shared-msw-handlers": "static-1.9439",
  "cms-field-types": "static-1.4589",
  "content-icons-ui": "static-1.2148",
  "conversations-skeleton-state": "static-1.7032",
  "crm-message-bus": "static-1.42312",
  "customer-data-filters-ui-msw-helpers": "static-1.21286",
  "customer-data-ui-utilities": "static-1.9609",
  "FormUrlGenerator": "static-2.4514",
  "framework-builder-read-service-client": "static-1.3817",
  "framework-data-schema-quick-fetch": "static-1.6559",
  "multi-account-reference-resolvers": "static-1.755",
  "onboarding-tours": "static-1.16233",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.12991",
  "academy-common-lib": "static-1.12909",
  "content-assistance-lib": "static-1.7425",
  "dashboard-lib": "static-1.80565",
  "file-manager-components": "static-1.22844",
  "getting-started-shared-tasks": "static-1.17840",
  "hubspot-prosemirror": "static-1.17565",
  "hubspot-prosemirror-plugins": "static-1.17557",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19443",
  "share-with-third-party-component-lib": "static-1.8476",
  "ui-addon-draggable": "static-3.4550",
  "ui-asset-management-lib": "static-1.10686",
  "ui-business-units-lib": "static-1.8810",
  "user-context": "static-1.4879",
  "growth-payments-core": "static-1.24686",
  "reporting-plugins": "static-1.9960",
  "reporting-reports": "static-1.66129",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.509",
  "codemirror": "static-5.90",
  "feedback-loader": "static-1.28824",
  "react-codemirror": "static-1.10411",
  "apps-service-types": "static-1.3663",
  "oauth-service-types": "static-1.4026",
  "onboarding-scopes": "static-1.6247",
  "onboarding-tours-client": "static-1.4447",
  "platform-infra-nav-components": "static-1.7477",
  "subscription-experience-data-types": "static-1.14566",
  "crm-record-cards-service-types": "static-1.3437",
  "location-customization-utils-lib": "static-1.8515",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4301",
  "nav-client-types": "static-1.2140",
  "purchase-motions-api": "static-1.5463",
  "signup-constants": "static-1.18352",
  "signup-ui-url-generator": "static-2.7852",
  "trials-service-types": "static-1.3702",
  "card-properties-lib": "static-1.43476",
  "crm-actions": "static-1.6081",
  "crm-cards-data": "static-1.1175",
  "crm-cards-sdk": "static-1.42872",
  "customer-data-properties": "static-1.50758",
  "customer-data-properties-shared-msw-handlers": "static-1.8768",
  "customer-data-tracking": "static-1.6665",
  "conditional-properties-service-client": "static-1.3608",
  "crm-pipelines-api-client-types": "static-1.3949",
  "multi-currency-client-types": "static-1.3502",
  "external-options-client-types": "static-1.3969",
  "react-dnd-compat": "static-1.4406",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5135",
  "growth-onboarding-confetti": "static-1.2854",
  "growth-onboarding-next-action-utils": "static-1.1280",
  "onboarding-tours-utils": "static-1.299",
  "ui-shepherd-tracker": "static-1.7310",
  "academy-service-client": "static-1.3465",
  "final-form": "static-1.65",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.27902",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8169",
  "video-components-external": "static-1.10515",
  "video-data-lib": "static-1.34173",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8353",
  "payment-link-components": "static-1.22901",
  "ui-addon-emoji-picker": "static-1.9673",
  "EmailSignatureEditor": "static-1.23874",
  "viral-links-lib": "static-1.6817",
  "data-token-picker": "static-1.16015",
  "FileManagerLib": "static-1.38484",
  "react-flip-move": "static-1.65",
  "timezone-utils": "static-2.5029",
  "getting-started-shared-tasks-store": "static-1.16958",
  "campaign-roi-lib": "static-1.8226",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.174",
  "eligibility-engine-service-types": "static-1.2983",
  "crm_data": "static-4.91159",
  "crm-links": "static-1.6042",
  "customer-data-sidebar": "static-2.45373",
  "enrichment-properties-lib": "static-1.14961",
  "crm-fe-perf": "static-1.22689",
  "calling-global-api": "static-1.63601",
  "calling-internal-common": "static-1.31075",
  "calling-lifecycle-internal": "static-1.64983",
  "calling-lifecycle-messages": "static-1.57277",
  "commerce-products-lib": "static-1.8817",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.459",
  "inbounddb-objects-service-types": "static-1.4034",
  "meetings-icalendar-utils-lib": "static-1.417",
  "object-builder-ui-client": "static-1.47917",
  "pipeline-validation-client-types": "static-1.3771",
  "property-value-citations": "static-1.1372",
  "pulse": "static-1.290",
  "smart-property-lib": "static-1.5843",
  "tiered-pricing": "static-1.804",
  "ui-addon-form-validation": "static-1.10778",
  "growth-onboarding-feedback-components": "static-1.6369",
  "content-media-composition-data-lib": "static-1.11396",
  "content-media-compositions": "static-2.15403",
  "media-bridge-lib": "static-1.18537",
  "commerce-tours-lib": "static-1.5692",
  "growth-onboarding-reliability": "static-1.4871",
  "sales-checkout-service-client": "static-1.3462",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21281",
  "sales-email-signature-service-client": "static-1.3629",
  "audio-components": "static-1.5589",
  "FileManagerCore": "static-1.38343",
  "FileManagerImages": "static-1.35995",
  "video-components": "static-1.12518",
  "crm_universal": "static-1.21633",
  "customer-data-email": "static-1.17642",
  "calling-error-reporting": "static-1.31081",
  "card-payment-highlight-lib": "static-1.36463",
  "card-subscription-highlight-lib": "static-1.38819",
  "commerce-billing-lib": "static-1.18460",
  "commerce-contract-lib": "static-1.11110",
  "customer-data-content": "static-1.26844",
  "invoices-highlight-card-lib": "static-1.53968",
  "orders-highlight-card-lib": "static-1.20831",
  "products-highlight-card-lib": "static-1.17101",
  "project-storage": "static-1.4516",
  "quotes-highlight-card-lib": "static-1.71111",
  "breeze-intelligence-kit": "static-1.5298",
  "crm-source-interpretation-lib": "static-1.5112",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9524",
  "policy-lib": "static-1.6567",
  "shared-worker-versioning": "static-1.10821",
  "calling-usage-tracker": "static-1.6323",
  "voice-sms-access-library": "static-1.201",
  "products-iframe-lib": "static-1.7271",
  "products-ui-components-shared-msw-handlers": "static-1.9823",
  "directed-graph": "static-1.721",
  "event-emitter": "static-1.731",
  "react-tinymce": "static-1.54575",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9587",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53701",
  "tinymce-plugins": "static-1.56815",
  "tinymce-themes": "static-1.55671",
  "hls.js": "static-1.34",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4317",
  "video-embed": "static-1.35007",
  "social-insights-client-types": "static-1.21279",
  "sequences-lib": "static-1.7664",
  "ui-gdpr-components": "static-1.10131",
  "commerce-shared-components-lib": "static-1.17872",
  "commerce-subscription-lib": "static-1.36396",
  "commerce-tools-ui-lib": "static-1.9753",
  "utility-belt": "static-1.2326",
  "payments-enrollment-embed-lib": "static-1.21954",
  "products-ui-components": "static-1.39336",
  "quotes-client-types": "static-1.37199",
  "quotes-ui-lib": "static-1.79830",
  "SalesContentIndexUI": "static-3.8876",
  "accounting-integrations-ui-components": "static-1.6698",
  "invoices-ui-lib": "static-1.53984",
  "commerce-products-api": "static-1.1933",
  "SafeStorage": "static-1.4188",
  "invoices-iframe-lib": "static-1.56042",
  "quotes-modal-lib": "static-1.101787",
  "calling-orchestration-schema": "static-1.34978",
  "sales-views-client-types": "static-1.4076",
  "hub-http-contrib": "static-1.2829",
  "interframe": "static-3.4575",
  "tinymce-data": "static-1.39786",
  "ui-addon-sales-email": "static-1.4997",
  "layout-dnd-components": "static-1.12004",
  "layout-dnd-utils": "static-1.10979",
  "ui-brand-identity-lib": "static-1.13796",
  "NamespacedHubStyle": "static-2.8881",
  "outpost": "static-1.3989",
  "sequences-client-types-lib": "static-1.7521",
  "customer-data-associations": "static-1.7120",
  "framework-data-table": "static-2.11373",
  "customer-data-rte": "static-1.32407",
  "cv-backend-services": "static-1.1497",
  "growth-onboarding-empty-states": "static-1.5339",
  "InboxConnectUtils": "static-4.14182",
  "payments-post-enroll-local-storage-lib": "static-1.4896",
  "qrcode-generator": "static-1.64",
  "stripe-embedded-components": "static-1.7105",
  "commerce-permissions": "static-1.536",
  "commerce-tax-lib": "static-1.296",
  "property-description-translator": "static-1.3643",
  "FireAlarmUi": "static-1.4314",
  "sales-templates-service-types-lib": "static-1.3979",
  "commerce-analytics-service-client": "static-1.3450",
  "totals-ui-components": "static-1.22959",
  "ContentData": "static-1.67652",
  "layout-data-lib": "static-1.9304",
  "deal-intel-decorators": "static-1.1204",
  "tanstack-virtual": "static-1.25",
  "draft-content-plugins": "static-1.27675",
  "stripe-connect-js": "static-1.64",
  "commerce-totals-service-types": "static-1.3622",
  "advanced-menus-core": "static-1.14788",
  "advanced-menus-lib": "static-1.11767",
  "ui-memberships-settings-lib": "static-1.33386",
  "deal-intel-utils": "static-1.1208",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14787",
  "simple-menus-lib": "static-1.16304"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11510",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.444",
  "dashboard-client-types": "/dashboard-client-types/static-1.214",
  "data-fetching-client": "/data-fetching-client/static-1.9463",
  "foundations-components": "/foundations-components/static-1.7492",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.517",
  "foundations-theming": "/foundations-theming/static-1.4194",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.77",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-test-utils": "/hs-test-utils/static-1.7789",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9441",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyleTokens": "/HubStyleTokens/static-2.11207",
  "I18n": "/I18n/static-7.1564",
  "jasmine-runner": "/jasmine-runner/static-1.6256",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11570",
  "quartz": "/quartz/static-1.6705",
  "react-dlb": "/react-dlb/static-1.71",
  "react-rhumb": "/react-rhumb/static-1.16427",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2646",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8384",
  "settings-ui-lib": "/settings-ui-lib/static-1.12306",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6697",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10919",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9332",
  "unified-auth": "/unified-auth/static-1.184",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.465",
  "usage-tracker": "/usage-tracker/static-1.7116",
  "usage-tracker-core": "/usage-tracker-core/static-1.6966",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7857",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.5966",
  "integrations-lib": "/integrations-lib/static-1.15367",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.18892",
  "property-management-iframe": "/property-management-iframe/static-1.12267",
  "quartz-config": "/quartz-config/static-1.483",
  "quartz-core": "/quartz-core/static-1.5924",
  "quartz-routing": "/quartz-routing/static-1.135",
  "quick-fetch": "/quick-fetch/static-1.3719",
  "react": "/react/static-7.177",
  "rpc-client-utils": "/rpc-client-utils/static-1.4416",
  "ts-schema": "/ts-schema/static-1.3888",
  "ui-universal-auth": "/ui-universal-auth/static-1.8670",
  "UIComponents": "/UIComponents/static-3.8154",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9391",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.84",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3211",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2982",
  "quartz-webpack": "/quartz-webpack/static-1.2929",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3761",
  "floating-ui": "/floating-ui/static-1.51",
  "foundations-assets": "/foundations-assets/static-1.4619",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1910",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9213",
  "react-aria": "/react-aria/static-1.61",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5158",
  "react-virtualized": "/react-virtualized/static-2.94",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1145",
  "ui-fonts": "/ui-fonts/static-1.469",
  "ui-images": "/ui-images/static-2.1087",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2677",
  "foundations-theming-base": "/foundations-theming-base/static-1.3179",
  "stylex": "/stylex/static-1.27",
  "HeadJS": "/HeadJS/static-2.706",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2900",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4112",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8306",
  "ai-rendering-library": "/ai-rendering-library/static-1.9249",
  "chirp-fetch": "/chirp-fetch/static-1.1667",
  "connections-embed-lib": "/connections-embed-lib/static-1.603",
  "copilot-toolkit": "/copilot-toolkit/static-1.10482",
  "laboratory-lib": "/laboratory-lib/static-3.6946",
  "marketplace-embed": "/marketplace-embed/static-1.21442",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8788",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18848",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13063",
  "sanitize-text": "/sanitize-text/static-1.7923",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8479",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5530",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4802",
  "wootric-nps": "/wootric-nps/static-1.6766",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4432",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3938",
  "highcharts": "/highcharts/static-8.99",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2385",
  "reporting-data": "/reporting-data/static-1.66451",
  "cssUtils": "/cssUtils/static-1.726",
  "flux-actions": "/flux-actions/static-1.306",
  "HubStyle": "/HubStyle/static-2.11515",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.9995",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10157",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7106",
  "icons": "/icons/static-2.620",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17425",
  "storybook-react": "/storybook-react/static-1.28",
  "trellis-story-utils": "/trellis-story-utils/static-1.4307",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4975",
  "quartz-i18n": "/quartz-i18n/static-1.380",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3515",
  "customer-data-objects": "/customer-data-objects/static-1.7430",
  "property-translator": "/property-translator/static-1.5197",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7708",
  "hs-promise-utils": "/hs-promise-utils/static-1.5376",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4664",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12782",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5369",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7572",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4259",
  "superstore": "/superstore/static-1.4555",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9929",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7406",
  "hub-http-janus": "/hub-http-janus/static-1.789",
  "hubspotter-http": "/hubspotter-http/static-1.4462",
  "immutable-less": "/immutable-less/static-1.4437",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16299",
  "nav-meta": "/nav-meta/static-1.28856",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10020",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17628",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3660",
  "property-management-common": "/property-management-common/static-1.4554",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8827",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.479",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.380",
  "quartz-head": "/quartz-head/static-1.370",
  "quartz-test": "/quartz-test/static-1.380",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2926",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20243",
  "ContentUtils": "/ContentUtils/static-1.67577",
  "sassPrefix": "/sassPrefix/static-1.151",
  "avatar-components": "/avatar-components/static-1.2268",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38852",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12789",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12926",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13449",
  "ExportDialog": "/ExportDialog/static-6.10170",
  "highlight.js": "/highlight.js/static-1.74",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40617",
  "reporting-snowflake": "/reporting-snowflake/static-1.55069",
  "reporting-ui-components": "/reporting-ui-components/static-2.63722",
  "reporting-visualizations": "/reporting-visualizations/static-1.58527",
  "ui-addon-teams": "/ui-addon-teams/static-1.21218",
  "magpie-lib": "/magpie-lib/static-1.5378",
  "magpie-types": "/magpie-types/static-1.4838",
  "simple-logging-lib": "/simple-logging-lib/static-1.2834",
  "navigation-components": "/navigation-components/static-1.17219",
  "ai-studio-lib": "/ai-studio-lib/static-1.10956",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10251",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7769",
  "ui-tool-access": "/ui-tool-access/static-1.9928",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7960",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5533",
  "usage-tracker-public": "/usage-tracker-public/static-1.6927",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3402",
  "persist-promise": "/persist-promise/static-1.3490",
  "reference-resolvers": "/reference-resolvers/static-1.7945",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3730",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.123",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2782",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2145",
  "merchandise-lib": "/merchandise-lib/static-1.258",
  "atom": "/atom/static-1.4854",
  "purchase-motions-components": "/purchase-motions-components/static-1.5460",
  "salesImages": "/salesImages/static-1.520",
  "batch-promise": "/batch-promise/static-1.1333",
  "crm-component-utils": "/crm-component-utils/static-1.38454",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5655",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6654",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7875",
  "navigation-messaging": "/navigation-messaging/static-1.6546",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9439",
  "cms-field-types": "/cms-field-types/static-1.4589",
  "content-icons-ui": "/content-icons-ui/static-1.2148",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7032",
  "crm-message-bus": "/crm-message-bus/static-1.42312",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21286",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9609",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4514",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6559",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.755",
  "onboarding-tours": "/onboarding-tours/static-1.16233",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12991",
  "academy-common-lib": "/academy-common-lib/static-1.12909",
  "content-assistance-lib": "/content-assistance-lib/static-1.7425",
  "dashboard-lib": "/dashboard-lib/static-1.80565",
  "file-manager-components": "/file-manager-components/static-1.22844",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17840",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17565",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17557",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19443",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8476",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4550",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10686",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8810",
  "user-context": "/user-context/static-1.4879",
  "growth-payments-core": "/growth-payments-core/static-1.24686",
  "reporting-plugins": "/reporting-plugins/static-1.9960",
  "reporting-reports": "/reporting-reports/static-1.66129",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.509",
  "codemirror": "/codemirror/static-5.90",
  "feedback-loader": "/feedback-loader/static-1.28824",
  "react-codemirror": "/react-codemirror/static-1.10411",
  "apps-service-types": "/apps-service-types/static-1.3663",
  "oauth-service-types": "/oauth-service-types/static-1.4026",
  "onboarding-scopes": "/onboarding-scopes/static-1.6247",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4447",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7477",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14566",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3437",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8515",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4301",
  "nav-client-types": "/nav-client-types/static-1.2140",
  "purchase-motions-api": "/purchase-motions-api/static-1.5463",
  "signup-constants": "/signup-constants/static-1.18352",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7852",
  "trials-service-types": "/trials-service-types/static-1.3702",
  "card-properties-lib": "/card-properties-lib/static-1.43476",
  "crm-actions": "/crm-actions/static-1.6081",
  "crm-cards-data": "/crm-cards-data/static-1.1175",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42872",
  "customer-data-properties": "/customer-data-properties/static-1.50758",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8768",
  "customer-data-tracking": "/customer-data-tracking/static-1.6665",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3608",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3949",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3502",
  "external-options-client-types": "/external-options-client-types/static-1.3969",
  "react-dnd-compat": "/react-dnd-compat/static-1.4406",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5135",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2854",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1280",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.299",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7310",
  "academy-service-client": "/academy-service-client/static-1.3465",
  "final-form": "/final-form/static-1.65",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27902",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8169",
  "video-components-external": "/video-components-external/static-1.10515",
  "video-data-lib": "/video-data-lib/static-1.34173",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8353",
  "payment-link-components": "/payment-link-components/static-1.22901",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9673",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23874",
  "viral-links-lib": "/viral-links-lib/static-1.6817",
  "data-token-picker": "/data-token-picker/static-1.16015",
  "FileManagerLib": "/FileManagerLib/static-1.38484",
  "react-flip-move": "/react-flip-move/static-1.65",
  "timezone-utils": "/timezone-utils/static-2.5029",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16958",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8226",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.174",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2983",
  "crm_data": "/crm_data/static-4.91159",
  "crm-links": "/crm-links/static-1.6042",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45373",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14961",
  "crm-fe-perf": "/crm-fe-perf/static-1.22689",
  "calling-global-api": "/calling-global-api/static-1.63601",
  "calling-internal-common": "/calling-internal-common/static-1.31075",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64983",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57277",
  "commerce-products-lib": "/commerce-products-lib/static-1.8817",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.459",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4034",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.417",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47917",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3771",
  "property-value-citations": "/property-value-citations/static-1.1372",
  "pulse": "/pulse/static-1.290",
  "smart-property-lib": "/smart-property-lib/static-1.5843",
  "tiered-pricing": "/tiered-pricing/static-1.804",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10778",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6369",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11396",
  "content-media-compositions": "/content-media-compositions/static-2.15403",
  "media-bridge-lib": "/media-bridge-lib/static-1.18537",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5692",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4871",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3462",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21281",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3629",
  "audio-components": "/audio-components/static-1.5589",
  "FileManagerCore": "/FileManagerCore/static-1.38343",
  "FileManagerImages": "/FileManagerImages/static-1.35995",
  "video-components": "/video-components/static-1.12518",
  "crm_universal": "/crm_universal/static-1.21633",
  "customer-data-email": "/customer-data-email/static-1.17642",
  "calling-error-reporting": "/calling-error-reporting/static-1.31081",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36463",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38819",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18460",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11110",
  "customer-data-content": "/customer-data-content/static-1.26844",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53968",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20831",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17101",
  "project-storage": "/project-storage/static-1.4516",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71111",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5298",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5112",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9524",
  "policy-lib": "/policy-lib/static-1.6567",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10821",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6323",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.201",
  "products-iframe-lib": "/products-iframe-lib/static-1.7271",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9823",
  "directed-graph": "/directed-graph/static-1.721",
  "event-emitter": "/event-emitter/static-1.731",
  "react-tinymce": "/react-tinymce/static-1.54575",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9587",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53701",
  "tinymce-plugins": "/tinymce-plugins/static-1.56815",
  "tinymce-themes": "/tinymce-themes/static-1.55671",
  "hls.js": "/hls.js/static-1.34",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4317",
  "video-embed": "/video-embed/static-1.35007",
  "social-insights-client-types": "/social-insights-client-types/static-1.21279",
  "sequences-lib": "/sequences-lib/static-1.7664",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10131",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17872",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36396",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9753",
  "utility-belt": "/utility-belt/static-1.2326",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21954",
  "products-ui-components": "/products-ui-components/static-1.39336",
  "quotes-client-types": "/quotes-client-types/static-1.37199",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.79830",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8876",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6698",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.53984",
  "commerce-products-api": "/commerce-products-api/static-1.1933",
  "SafeStorage": "/SafeStorage/static-1.4188",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56042",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101787",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34978",
  "sales-views-client-types": "/sales-views-client-types/static-1.4076",
  "hub-http-contrib": "/hub-http-contrib/static-1.2829",
  "interframe": "/interframe/static-3.4575",
  "tinymce-data": "/tinymce-data/static-1.39786",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4997",
  "layout-dnd-components": "/layout-dnd-components/static-1.12004",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10979",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13796",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8881",
  "outpost": "/outpost/static-1.3989",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7521",
  "customer-data-associations": "/customer-data-associations/static-1.7120",
  "framework-data-table": "/framework-data-table/static-2.11373",
  "customer-data-rte": "/customer-data-rte/static-1.32407",
  "cv-backend-services": "/cv-backend-services/static-1.1497",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5339",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14182",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4896",
  "qrcode-generator": "/qrcode-generator/static-1.64",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7105",
  "commerce-permissions": "/commerce-permissions/static-1.536",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.296",
  "property-description-translator": "/property-description-translator/static-1.3643",
  "FireAlarmUi": "/FireAlarmUi/static-1.4314",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3979",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3450",
  "totals-ui-components": "/totals-ui-components/static-1.22959",
  "ContentData": "/ContentData/static-1.67652",
  "layout-data-lib": "/layout-data-lib/static-1.9304",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1204",
  "tanstack-virtual": "/tanstack-virtual/static-1.25",
  "draft-content-plugins": "/draft-content-plugins/static-1.27675",
  "stripe-connect-js": "/stripe-connect-js/static-1.64",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3622",
  "advanced-menus-core": "/advanced-menus-core/static-1.14788",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11767",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33386",
  "deal-intel-utils": "/deal-intel-utils/static-1.1208",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14787",
  "simple-menus-lib": "/simple-menus-lib/static-1.16304"
}
};
